import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  translateService = inject(TranslateService);

  setLanguage(lang: string) {
    new Promise((resolve, reject) => {
      this.translateService.use(lang);
      localStorage.setItem('lang', lang);
      resolve(true);
    });
  }

  getCurrentLanguage(): 'en' | 'vi' {
    return (localStorage.getItem('lang') || 'en') as 'en' | 'vi';
  }
}
